"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var t = _interopRequireWildcard(require("./types"));
var _util = require("../../util");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? Object(arguments[i]) : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys.push.apply(ownKeys, Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var initialState = {
  currentStep: 0,
  claimInfo: {},
  imageInfo: {},
  imageMetaData: [],
  imageUploadStatus: false,
  locationInfo: {}
};
var claimsReducer = (0, _util.createReducer)(initialState)(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, t.UPDATE_STEP, function (state, action) {
  return _objectSpread({}, state, {
    currentStep: action.payload
  });
}), t.UPLOAD_IMAGE_SUCCESS, function (state, action) {
  return _objectSpread({}, state, {
    imageUploadStatus: action.payload
  });
}), t.REGISTER_CLAIM_INFO, function (state, action) {
  return _objectSpread({}, state, {
    claimInfo: _objectSpread({}, state.claimInfo, action.payload)
  });
}), t.SUBMIT_CLAIM_SUCCESS, function (state, action) {
  return _objectSpread({}, state, {
    response: action.payload
  });
}), t.SUBMIT_CLAIM_FAILURE, function (state, action) {
  return _objectSpread({}, state, {
    response: action.payload.response
  });
}), t.CLEAR_CLAIM_INFO, function (state, action) {
  return initialState;
}), t.SUBMIT_IMAGE_SUCCESS, function (state, action) {
  var fileUrl = action.payload.fileUrl;
  var fileEntryId = action.payload.fileEntryId;
  var item = {
    FilePath: fileUrl,
    Id: fileEntryId
  };
  return _objectSpread({}, state, {
    imageUploadStatus: action.payload,
    imageInfo: action.payload,
    imageMetaData: [].concat(state.imageMetaData, [item])
  });
}), t.SUBMIT_IMAGE_FAILURE, function (state, action) {
  return _objectSpread({}, state, {
    imageInfo: action.payload.response
  });
}), t.LOCATION_SUCCESS, function (state, action) {
  var locationData = action.payload;
  if (locationData.status === 'OK') {
    if (locationData.results[0]) {
      var addressComponent = locationData.results[0].address_components;
      var streetNum = '',
        route = '',
        locality = '',
        administrative_area = '',
        country = '',
        postal_code = '';
      addressComponent.forEach(function (item) {
        if (item.types.indexOf('street_number') > -1) {
          streetNum = item.short_name;
        } else if (item.types.indexOf('route') > -1) {
          route = item.short_name;
        } else if (item.types.indexOf('locality') > -1) {
          locality = item.short_name;
        } else if (item.types.indexOf('administrative_area_level_1') > -1) {
          administrative_area = item.short_name;
        } else if (item.types.indexOf('country') > -1) {
          country = item.short_name;
        } else if (item.types.indexOf('postal_code') > -1) {
          postal_code = item.short_name;
        }
      });
      locationData.address = {
        streetAddress: streetNum + ' ' + route,
        city: locality,
        state: administrative_area,
        country: country,
        postalCode: postal_code,
        formattedAddress: locationData.results[0].formatted_address
      };
    }
  }
  return _objectSpread({}, state, {
    locationInfo: locationData
  });
}), t.LOCATION_FAILURE, function (state, action) {
  return _objectSpread({}, state, {
    locationInfo: {}
  });
}));
var _default = exports.default = claimsReducer;